import $ from 'jquery'
import 'select2/dist/js/select2.full.min'
import 'select2/dist/js/i18n/ru'
import toastr from '../../utils/toastr'
import i18n from '../../utils/translate'

class Module {
  constructor ($module) {
    this.$module = $module
    this.$company = $module.find('#yandex_subscription_campaign_company_name')
    this.$companyId = $module.find('#yandex_subscription_campaign_company_id')
    this.$country = $module.find(
      '#yandex_subscription_campaign_company_country')
    
    this.$campaignProduct = $module.find(
      'input[name="yandex_subscription_campaign[product]"]')
    this.$campaignUrl = $module.find('#yandex_subscription_campaign_url')
    this.$form = $module.find('form')
    
    this.retryCounter = 5
    this.timer = null
    
    this.init()
  }
  
  checkCampaignUrl () {
    
    if (this.$campaignProduct.filter((i, item) => $(item).is(':checked')).val() === 'WEB') {
      this.$campaignUrl.attr('required', 'required')
      this.$campaignUrl.removeAttr('disabled')
      this.$campaignUrl.closest('.form-group').show()
    } else {
      this.$campaignUrl.attr('disabled', 'disabled')
      this.$campaignUrl.removeAttr('required')
      this.$campaignUrl.closest('.form-group').hide()
    }
    
    this.$campaignUrl.trigger('change')
  }
  
  init () {
    let self = this
  
    $('[data-toggle="tooltip"]', this.$module).on('inserted.bs.tooltip',function () {
      var thisClass = $(this).attr("data-tooltip-class");
      $('.tooltip').addClass(thisClass);
    })
    
    
    this.$company.select2({
      width: '100%',
      minimumInputLength: 2,
      ajax: {
        processResults: function (data) {
          return {
            results: data.items.map(function (i) {
              let country = typeof i.country !== 'undefined'
                ? i.country.geoId
                : i.chainCountries[0].geoId
              
              return {
                id: i.name,
                companyId: i.id,
                text: i.name + ' (' + i.address + ')',
                country: country
              }
            }),
            pagination: {
              more: data.pagination.offset + data.pagination.limit <
                data.pagination.total
            }
          }
        }
      }
    })
    
    this.$company.on('select2:select', function (e) {
      self.$companyId.val(e.params.data.companyId)
      self.$country.val(e.params.data.country)
    })
    
    this.$campaignProduct.change(function () {
      self.checkCampaignUrl()
    })
    
    this.checkCampaignUrl()
    
    this.$form.on('submit', (e) => {
      e.preventDefault()
      if (!!window.ym) {
        ym(32793525, 'reachGoal', 'ya-business-submit')
      }
      self.trySubmit()
    })
  }
  
  redirectToList () {
    window.location.href = `/ru/yandex-business/${this.$form.data(
      'account-id')}/campaigns`
  }
  
  redirectToStart (id) {
    window.location.href = `/ru/yandex-business/${this.$form.data(
      'account-id')}/campaigns/${id}/start`
  }
  
  trySubmit () {
    let self = this
    self.$form.trigger('toggleProcessing')
    self.retryCounter--
    
    let formData = new FormData(self.$form[0])
    
    let data = {
      name: formData.get('yandex_subscription_campaign[name]'),
      company: {
        id: formData.get('yandex_subscription_campaign[company][id]'),
        country: formData.get('yandex_subscription_campaign[company][country]')
      },
      product: formData.get('yandex_subscription_campaign[product]')
    }
    
    if (!!formData.get('yandex_subscription_campaign[url]')) {
      data.url = formData.get('yandex_subscription_campaign[url]')
    }
    
    $.ajax({
      url: `/api/app/v1/networks/yandex-subscription/${self.$form.data(
        'account-id')}/campaign`,
      method: 'POST',
      data: data,
      dataType: 'json'
    }).done((response) => {
      
      if (response.data.state === 'READY') {
        self.redirectToStart(response.data.campaign.id)
      } else {
        
        if (self.retryCounter === 0) {
        
        if (window.ym) {
            ym(32793525,'reachGoal','ya-business-slow-processing')
        }
          
          clearTimeout(this.timer)
          toastr.success(i18n.gettext('yandex_subscription.slow_processing'))
          setTimeout(() => {
            self.redirectToList()
          }, 3000)
        } else {
          self.timer = setTimeout(() => {
            clearTimeout(self.timer)
            self.trySubmit()
          }, 5000)
        }
        
      }
    }).fail((resp) => {
      self.retryCounter = 5
      toastr.error(i18n.gettext(resp.responseJSON.errors[0]))
    }).always(() => {
      self.$form.trigger('toggleProcessing')
    })
  }
}

$(function () {
  $('.js-yandex-subscription-new-campaign').each(function () {
    new Module($(this))
  })
})
